import { httpsCallable } from 'firebase/functions'
import { functions } from './firebase'
import type { ServiceTicket, TicketSeverity, TicketStatus, TicketType } from '@/types/tickets'

const call = <T>(name: string, data?: Record<string, unknown>) => {
  if (!functions) throw new Error('Firebase is not configured.')
  return httpsCallable<Record<string, unknown> | undefined, T>(functions, name)(data).then(result => result.data)
}

export interface CreateTicketInput {
  type: TicketType
  severity: TicketSeverity
  title?: string
  details?: string
  mistakes?: string
  whatWentWell?: string
  planId?: string
  checklistId?: string
  checklistTitle?: string
  checklistPhase?: 'prep' | 'final' | 'post'
}

export const createServiceTicket = (input: CreateTicketInput) => call<{ ticket: ServiceTicket }>('createServiceTicket', input as unknown as Record<string, unknown>).then(result => result.ticket)
export const listServiceTickets = () => call<{ tickets: ServiceTicket[] }>('listServiceTickets').then(result => result.tickets)
export const updateServiceTicketStatus = (ticketId: string, status: TicketStatus) => call<{ ticket: ServiceTicket }>('updateServiceTicketStatus', { ticketId, status }).then(result => result.ticket)
